import { SIZE } from 'common/sizes';
import styled from 'styled-components';

interface IRootProps {
  radius?: string;
  height?: string;
  displayValue?: string;
}

export const Root = styled.div`
  height:auto;
  width:auto;
  display: ${(props: IRootProps) => (props.displayValue ?? `inline-block`)};
  font-family: Rubik;
`;

export const BtnMore = styled.button`
  width: 41px;
  height: ${(props: IRootProps) => props.height};
  flex-grow: 0;
  border-radius: ${(props: IRootProps) => props.radius};
  background-color: #f5f5f5;
  border:unset;
  font-family: Rubik;
  font-size: 12px;
  font-weight: normal;
  text-align: center;
  color: #202020;
  cursor: pointer;
`;

export const MenuChips = styled.div`
  min-width: 220px;
  height: auto;
  display: none;
  position: absolute;
  border-radius: 20px 0px 20px 20px;
  box-shadow: 5px 4px 10px 0 rgba(0, 0, 0, 0.08);
  background-color: #f5f5f5;
  z-index: 1;
  margin-left: -179px;
  margin-top: -1px;
  padding: 13px 0px;
`

export const Scroll = styled.div`
    height:auto;
    max-height: 400px;
    width: 95%;
    display: block;
    overflow-y: auto;
    position: relative;
`

export const Title = styled.div`
  width: auto;
  font-size: 12px;
  font-weight: normal;
  text-align: left;
  color: rgba(32, 32, 32, 0.5);
  padding: 10px 18px;
`

export const Chip = styled.span`
  width: auto;
  font-size: 12px;
  font-weight: normal;
  line-height:20px;
  text-align: left;
  color: #202020;
  display: block;
  border-bottom: 1px solid rgba(32, 64, 120, 0.1);
  padding: 15px 18px;
`

export const Remove = styled.div`
  margin: 0px 0px 0px 5px;
  border-radius: 20px;
  width: 20px;
  height: 20px;
  float: right;
  align-items: center;
  justify-content: center;
  text-align:center;
  background-color: #8a8a8a;
  cursor: pointer;
`

export const ClearAll = styled.div`
  width: 100%;
  font-size: 12px;
  font-weight: normal;
  text-align: center;
  color: rgba(32, 32, 32, 0.5);
  padding: 10px 0px;
  color: #ee3434;
  cursor: pointer;
`

export const ClearAllHide = styled.label`
  width: auto;
  height: 19px;
  margin-left: ${SIZE.TWO}px;
  cursor: pointer;

  font-family: Rubik;
  font-size: 16px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  display: ${(props: IRootProps) => (props.displayValue ?? `auto`)};
`;